import React from 'react';

export const AdminCompanyRequests = () => {

    return (
        <>

        </>
    );
};
